import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import styled, { ThemeProvider } from 'styled-components';
import { BaseModalBackground, ModalProvider } from 'styled-react-modal';
import theme from '@shared/theme';
import { GlobalStyle } from '@/styles/globalStyles';
import { Auth0ProviderWithConfig } from '@/auth/Auth0ProviderWithConfig';
import { queryClient } from '@/api/queryClient';
import { router } from '@/router';

const ModalBackdrop = styled(BaseModalBackground as any)`
    z-index: 3000;
`;

/**
 * Root of the SPA. Provider order mirrors the old Remix `root.tsx` tree, with
 * QueryClient + Auth0 added (they replace loaders/actions and the server-side
 * auth session respectively).
 */
export function App() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <ModalProvider backgroundComponent={ModalBackdrop}>
                <QueryClientProvider client={queryClient}>
                    <Auth0ProviderWithConfig>
                        <RouterProvider router={router} />
                    </Auth0ProviderWithConfig>
                </QueryClientProvider>
            </ModalProvider>
        </ThemeProvider>
    );
}
